module.exports = __webpack_public_path__ + "img/clouds-sun.9c2fe553.svg";